import Table from '../../../../common/filter-table/Table';
import { ViewDetails } from '../../../../common/filter-table/ViewDetails';
import { Private_Routes } from '../../../../constants';
import { formatStrings } from '../../../../utils/formatStrings';
import { PayrollNoveltyFlow } from '../../models/payrollNoveltyFlow';

interface Props {
    data: PayrollNoveltyFlow[];
    onSortingChange?: (columnName: string, sortOrder: 'asc' | 'desc') => void;
    sortedBy?: string | null;
    ascending?: boolean | null;
}

export const PayrollNoveltyFlowsTable = ({
    data,
    onSortingChange,
    sortedBy,
    ascending,
}: Props) => {
    const triggerSortingChange = (columnName: string, sortOrder: 'asc' | 'desc') => {
        if (onSortingChange) onSortingChange(columnName, sortOrder);
    };

    return (
        <Table
            sortedBy={sortedBy}
            ascending={ascending}
            onSortingChange={triggerSortingChange}
            columns={[
                {
                    isSortable: true,
                    name: 'Name',
                    title: 'Nombre',
                },

                {
                    isSortable: false,
                    name: 'IsForAllGroups',
                    title: 'Aplica para todos los grupos',
                },

                { isSortable: false, name: 'Actions', title: '' },
            ]}
        >
            {data.map((flow) => (
                <tr key={flow.id} className='text-dark'>
                    <td>{formatStrings.capitalizeNames(flow.name)}</td>

                    <td className='text-start'>
                        {flow.isForAllGroups ? (
                            <i className=' ri-checkbox-circle-line text-success fs-4'></i>
                        ) : (
                            ''
                        )}
                    </td>

                    <td className='d-flex justify-content-sm-end'>
                        {flow.id && (
                            <ViewDetails
                                href={Private_Routes.PAYROLL_NOVELTY_FLOWS.edit.replace(
                                    ':id',
                                    flow.id.toString()
                                )}
                            />
                        )}
                    </td>
                </tr>
            ))}
        </Table>
    );
};
